import { AddressModel } from '@steelbuy/ts-shared';

import { WarehouseAddressCollectionData } from './WarehouseAddressCollectionData';
import { useCollectionData } from '../../util/consumer/CollectionConsumerHook';

export const useWarehouseAddressCollectionData = () => useCollectionData<AddressModel>(WarehouseAddressCollectionData);
